import {
	formatTimeToYMDHms,
	socketType2DbType
} from '../functions/Common.js'
import {
	saveReceiveMsg,updateChatRecordById
} from '../network/local/chat-record.js'
import {
	saveClusterMsg
} from '../network/local/cluster-chat-record.js'
import {
	saveRecently
} from '../network/local/recently.js'
import {webUpdateRecodeWithRR} from '../network/web/chat-record.js'
import {getFansById,saveFriend} from '../network/local/friend.js'
import {webGetFans} from '../network/web/friend.js'



// 消息基本处理，区分群消息和普通消息
export function handleMsg(bean, vthis) {
	if (bean.msgType === undefined) {
		return
	}
	if (bean.msgType == 1) {
		getFansInfo(bean.friendId,data=>{
			handleNormalMsg(bean, vthis)
		})
	} else if (bean.msgType == 2) {
		handleClusterMsg(bean, vthis)
	}
}

// 保存收到的消息/发送的时的消息到本地-普通消息
export function handleNormalMsg(bean, vthis) {
	saveReceiveMsg(bean, (data) => {
		if (data !== false) {
			let fans_name = data.con_remark !== undefined && data.con_remark !== '' && data.con_remark !== null ? data.con_remark : data.fans_wx_name
			// 整合最近聊天表所需要的数据
			let recentlyData = {
				id: bean.recentlyId,
				account_open_id: data.custom_wx_id,
				friends_open_id: data.fans_wx_id,
				friend_or_cluster_id: data.fans_id,
				friend_img: data.fans_wx_photo,
				friend_name:fans_name,
				chat_type: bean.msgType,
				last_chat_msg: bean.content,
				last_chat_msg_type: bean.type,
				last_modified_time: bean.time,
				is_new: 1,
				is_me: bean.is_me === undefined ? 0 : bean.is_me,
				msgToUp: bean.msgToUp === undefined ? 1 : bean.msgToUp
			}
			saveRecently(recentlyData, r_data => {
				if (r_data) {
					// 更新vuex状态值
					let is_send = 1
					if(bean.is_send !== undefined){
						is_send = bean.is_send
					}else{
						is_send = bean.is_me === 1 ? 2 : 1
					}
					let msg = {
						id: bean.recodeId,
						recentlyId: bean.recentlyId,
						from_photo: data.fans_wx_photo,
						is_me: bean.is_me === undefined ? 0 : bean.is_me,
						from_name: fans_name,
						send_time: formatTimeToYMDHms(bean.time),
						content: bean.content,
						type: socketType2DbType(bean.type),
						fans_id: data.fans_id,
						is_send:is_send,
						chatType: bean.msgType,
						other: bean.other === undefined ? null : JSON.stringify(bean.other),
						custom_id:data.custom_id,
						msgToUp: bean.msgToUp === undefined ? 1 : bean.msgToUp
					}
					vthis.$store.commit('updateCurrentChatMsg', msg)

					let recently = {
						id: bean.recentlyId,
						account_open_id: data.custom_wx_id,
						friends_open_id: data.fans_wx_id,
						friend_or_cluster_id: data.fans_id,
						friend_img: data.fans_wx_photo,
						friend_name: fans_name,
						chat_type: bean.msgType,
						last_chat_msg: bean.content,
						last_chat_msg_type: socketType2DbType(bean.type),
						last_modified_time: bean.time,
						is_new: 1,
						no_read_num: r_data.no_read_num,
						is_me: bean.is_me === undefined ? 0 : bean.is_me,
						is_top: r_data.is_top,
						is_collect: r_data.is_collect,
						no_disturb: r_data.no_disturb,
						is_transfer: r_data.is_transfer === undefined ? 0 : r_data.is_transfer,
						msgToUp: bean.msgToUp === undefined ? 1 : bean.msgToUp
					}
					vthis.$store.commit('updateCurrentRecentlyMsg', recently)
				}
			})
		}
	})
}

// 保存收到的消息/发送的时的消息到本地-群消息
export function handleClusterMsg(bean, vthis) {
	saveClusterMsg(bean, (data) => {
		if (data !== false) {
			// 整合最近聊天表所需要的数据
			let recentlyData = {
				id: bean.recentlyId,
				account_open_id: bean.toId,
				friends_open_id: bean.fromId,
				friend_or_cluster_id: bean.friendId,
				friend_img: bean.clusterImg,
				friend_name: bean.clusterName,
				chat_type: bean.msgType,
				last_chat_msg: bean.content,
				last_chat_msg_type: bean.type,
				last_modified_time: bean.time,
				is_new: 1,
				is_me: bean.is_me === undefined ? 0 : bean.is_me
			}
			saveRecently(recentlyData, r_data => {
				if (r_data) {
					// 更新vuex状态值
					let is_send = 1
					if(bean.is_send !== undefined){
						is_send = bean.is_send
					}else{
						is_send = bean.is_me === 1 ? 2 : 1
					}
					let msg = {
						id: bean.recodeId,
						recentlyId: bean.recentlyId,
						from_photo: bean.mPhoto,
						is_me: bean.is_me === undefined ? 0 : bean.is_me,
						from_name: bean.mWxName,
						send_time: formatTimeToYMDHms(bean.time),
						content: bean.content,
						type: socketType2DbType(bean.type),
						fans_id: bean.friendId,
						is_send: is_send,
						chatType: bean.msgType,
						toId: bean.toId
					}
					vthis.$store.commit('updateCurrentChatMsg', msg)

					let recently = {
						id: bean.recentlyId,
						account_open_id: bean.toId,
						friends_open_id: bean.fromId,
						friend_or_cluster_id: bean.friendId,
						friend_img: bean.clusterImg,
						friend_name: bean.clusterName,
						chat_type: bean.msgType,
						last_chat_msg: bean.content,
						last_chat_msg_type: socketType2DbType(bean.type),
						last_modified_time: bean.time,
						is_new: 1,
						no_read_num: r_data.no_read_num,
						is_me: bean.is_me === undefined ? 0 : bean.is_me,
						is_top: r_data.is_top,
						is_collect: r_data.is_collect,
						no_disturb: r_data.no_disturb
					}
					vthis.$store.commit('updateCurrentRecentlyMsg', recently)
				}
			})
		}
	})
}

// 更新红包消息和转账消息
export function changeRTStatus(bean,type,vthis) {
    if (bean === undefined){
            return;
        }
	if (type === undefined || type === ''){
		return;
	}
    let money = 0;
    let paymsgid = '';
    let transferid = '';
	let msgType = ''
    // 红包类型
    switch (type) {
        case 'redPackage':
			money = bean.money;
			paymsgid = bean.paymsgid
			msgType = 'red_package_d'
            break;
        case 'transferAccounts':
			transferid = bean.transferid
			if(bean.msgType !== undefined){
				msgType = bean.msgType
			}else{
				msgType = 'transfer_accounts_d'
			}
            break;
    }
	webUpdateRecodeWithRR(msgType,money,paymsgid,transferid,res=>{
		if(!res){
			return
		}
		updateChatRecordById(res.id,{type:msgType},res2=>{
			let s_data = JSON.parse(JSON.stringify(bean))
			s_data.id = res.id
			s_data.msgType = msgType
			vthis.$store.commit('updateOtherEvent', s_data)
		})
	})   
}

/**
 * 获取粉丝信息，先从本地数据库查询，如果没有，则从线上数据库查询
 * @param {Object} fansId
 * @param {Object} callback
 */
export function getFansInfo(fansId,callback){
	if(fansId === undefined || fansId === ""){
		if(callback !== undefined){
			callback(false)
		}
		return
	}
	// 查本地数据
	getFansById(fansId,data=>{
		if(data.id !== undefined){
			if(callback !== undefined){
				callback(data)
			}
			return
		}
		// 查询线上数据库数据
		webGetFans(fansId,data=>{
			if(data.code != 1 || data.data === undefined || data.data.id === undefined){
				if(callback !== undefined){
					callback(false)
				}
				return
			}
			// 保存粉丝信息
			let fans = data.data
			let bean = {
				friend_id: fans.id,
				custom_id: fans.custom_id,
				friend_open_id: fans.open_id,
				friend_name: fans.wx_name,
				friend_avatar: fans.wx_photo,
				friend_type: fans.friend_type,
				alias: fans.alias,
				con_remark: fans.con_remark,
				sex: fans.sex,
				country: fans.country,
				province: fans.province,
				city: fans.city,
				sign: fans.sign,
				fans_type: fans.fans_type,
				create_time: fans.create_time
			}
			saveFriend(bean,callback)
		})
	})
}
